import * as React from "react";

export const ClockIconRed = (props: any) => (
  <svg
    width={20}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 7H9v6l4.75 2.85.75-1.23-4-2.37V7ZM15.337.81l4.607 3.845-1.28 1.535-4.61-3.843L15.337.81ZM4.663.81l1.282 1.536L1.337 6.19.057 4.654 4.663.81ZM10 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 10 3Zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7Z"
      fill="#F43636"
    />
  </svg>
);
